import '@shoelace-style/shoelace/dist/components/progress-ring/progress-ring.js';

import { ApplicationElement, html } from '@effectivastudio/lit-components';
import style from './style.lit.css';

/**
 * Component that shows progress of an action.
 *
 * @prop value - Progress 0-100%
 *
 * @cssprop --radius - Component's radius
 */

export default class IconProgress extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    value: { type: Number },
    icon: { type: String },
  };

  constructor() {
    super();
    this.icon = 'check-circle:solid';
  }

  render() {
    return html`
      <sl-progress-ring value=${this.value}>
        <ef-icon name=${this.icon}></ef-icon>
      </sl-progress-ring>
    `;
  }
}

customElements.get('xs-icon-progress') ||
  customElements.define('xs-icon-progress', IconProgress);
